import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow2Directions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_199_810)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.8118 14.2309L19.3041 10.7386C19.7588 10.2839 19.7588 9.54545 19.3041 9.09073L15.8118 5.59849C15.3571 5.14377 14.6187 5.14377 14.1639 5.59849C13.7092 6.05321 13.7092 6.79167 14.1639 7.24639L15.67 8.75242H4.99316L6.49919 7.24639C6.95391 6.79167 6.95391 6.05321 6.49919 5.59849C6.04447 5.14377 5.30601 5.14377 4.85129 5.59849L1.35904 9.09073C0.904326 9.54545 0.904326 10.2839 1.35904 10.7386L4.85129 14.2309C5.30601 14.6856 6.04447 14.6856 6.49919 14.2309C6.95391 13.7762 6.95391 13.0377 6.49919 12.583L4.9968 11.0806H15.6736L14.1676 12.5866C13.7129 13.0413 13.7129 13.7798 14.1676 14.2345C14.6223 14.6892 15.3608 14.6892 15.8155 14.2345L15.8118 14.2309Z",
			fill: "#0D2976"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_199_810",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white",
			transform: "matrix(1 0 0 -1 0 20)"
		})
	}) })]
});
export default SvgArrow2Directions;
